import React from 'react';
import PropTypes from 'prop-types';

import useMenuContent from '@/utils/useMenuContent';

import ItemMenu from './ItemMenu';

const Header = ({ classes, currentPath, redirectTo }) => {
  const menu = useMenuContent();

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        {menu.slice(1).map(({ name, to }, index) => (
          <ItemMenu
            key={to || index}
            name={name}
            to={to}
            disabled={to === currentPath || (to === '/news/' && currentPath.includes('/news/'))}
            redirectTo={redirectTo}
          />
        ))}
      </div>
    </div>
  );
};

Header.propTypes = {
  currentPath: PropTypes.string.isRequired,
  redirectTo: PropTypes.func.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default Header;
